import { Component, OnInit, DestroyRef, ViewChild, Input, HostListener, inject, AfterViewInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { pagesToggleService } from '../../services/toggler.service';
import { Router, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { AuthenticationService } from '../../../_services/authentication.service';
import { DealSaveStateService } from '../../../_services/deal-save-state.service';
declare let pg: any;

@Component({
  selector: 'root-layout',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.scss'],
})
export class RootLayout implements OnInit, AfterViewInit {
  public isSavingDeal: boolean = false;
  public dealSaveState: DealSaveStateService;
  private destroyRef = inject(DestroyRef);
  @ViewChild('root', { static: false }) root;
  layoutState: string;
  extraLayoutClass: string;
  _boxed = false;
  _menuPin = false;
  _enableHorizontalContainer: boolean;
  _pageContainerClass = '';
  _contentClass = '';
  _footer = true;
  _menuDrawerOpen = false;
  //Mobile
  _secondarySideBar = false;
  //Mobile
  _mobileSidebar = false;
  //Mobile
  _mobileHorizontalMenu = false;
  _pageTitle: string;
  //Sub layout - eg: email
  _layoutOption: string;
  _layout;
  @Input()
  public contentClass = '';

  @Input()
  public pageWrapperClass = '';

  @Input()
  public footer = true;

  currUser;

  constructor(
      public toggler: pagesToggleService,
      private router: Router,
      private authService: AuthenticationService,
      dealSaveState: DealSaveStateService,
  ) {
    this.dealSaveState = dealSaveState;
    // Subscribe to saving state changes for all layouts
    this.dealSaveState.isSavingDeal$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(val => {
      this.isSavingDeal = val;
    });
    this.currUser = this.authService.getCurrentUser();
    console.log('curr user', this.currUser);

    if (this.layoutState) {
      pg.addClass(document.body, this.layoutState);
    }
    router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        let root = this.router.routerState.snapshot.root;
        while (root) {
          if (root.children && root.children.length) {
            root = root.children[0];
          }
          else if (root.data) {
            //Custom Route Data here
            this._pageTitle = root.data['title'];
            this._layoutOption = root.data['layoutOption'];
            this._boxed = root.data['boxed'];
            break;
          }
          else {
            break;
          }
        }
        //Reset Any Extra Layouts added from content pages
        pg.removeClass(document.body, this.extraLayoutClass);
        //Close Sidebar and Horizonta Menu
        if (this._mobileSidebar) {
          this._mobileSidebar = false;
          pg.removeClass(document.body, 'sidebar-open');
          this.toggler.toggleMobileSideBar(this._mobileSidebar);
        }
        this._mobileHorizontalMenu = false;
        this.toggler.toggleMobileHorizontalMenu(this._mobileHorizontalMenu);
        //Scoll Top
        this.scrollToTop();
      }
    });

    this.toggler.pageContainerClass.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(state => {
      this._pageContainerClass = state;
    });
    this.toggler.contentClass.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(state => {
      this._contentClass = state;
    });
    this.toggler.bodyLayoutClass.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(state => {
      if (state) {
        this.extraLayoutClass = state;
        pg.addClass(document.body, this.extraLayoutClass);
      }
    });
    this.toggler.Applayout.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(state => {
      this.changeLayout(state);
    });
    this.toggler.Footer.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(state => {
      this._footer = state;
    });
    this.toggler.mobileHorizontaMenu.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(state => {
      this._mobileHorizontalMenu = state;
    });
  }

  logout() {
    this.authService.logout();
  }
  /** @function changeLayout
   *   @description Add Document Layout Class
   */
  changeLayout(type: string) {
    this.layoutState = type;
    if (type) {
      pg.addClass(document.body, type);
    }
  }

  /** @function removeLayout
   *   @description Remove Document Layout Class
   */
  removeLayout(type: string) {
    pg.removeClass(document.body, type);
  }

  ngOnInit() {}

  ngAfterViewInit() {}

  /** @function scrollToTop
   *   @description Force to scroll to top of page. Used on Route
   */
  scrollToTop() {
    const top = window.pageYOffset;
    if (top == 0) {
      const scroller = document.querySelector('.page-container');
      if (scroller) { scroller.scrollTo(0, 0); }
    }
    else {
      window.scrollTo(0, 0);
    }
  }

  /** @function openQuickView
   *   @description Show Quick View Component / Right Sidebar - Service
   */
  openQuickView($e) {
    $e.preventDefault();
    this.toggler.toggleQuickView();
  }

  /** @function openSearch
   *   @description Show Quick Search Component - Service
   */

  openSearch($e) {
    $e.preventDefault();
    this.toggler.toggleSearch(true);
  }

  /** @function toggleMenuPin
   *   @description Permanently Open / Close Main Sidebar
   */
  toggleMenuPin($e) {
    if (pg.isVisibleSm()) {
      this._menuPin = false;
      return;
    }
    if (this._menuPin) {
      pg.removeClass(document.body, 'menu-pin');
      this._menuPin = false;
    }
    else {
      pg.addClass(document.body, 'menu-pin');
      this._menuPin = true;
    }
  }

  /** @function toggleMenuDrawer
   *   @description Open Main Sidebar Menu Drawer - Service
   */
  toggleMenuDrawer() {
    this._menuDrawerOpen = this._menuDrawerOpen == true ? false : true;
    this.toggler.toggleMenuDrawer();
  }

  /** @function toggleMobileSidebar
   *   @description Open Main Sidebar on Mobile - Service
   */
  toggleMobileSidebar() {
    if (this._mobileSidebar) {
      this._mobileSidebar = false;
      pg.removeClass(document.body, 'sidebar-open');
    }
    else {
      this._mobileSidebar = true;
      pg.addClass(document.body, 'sidebar-open');
    }
    this.toggler.toggleMobileSideBar(this._mobileSidebar);
  }

  /** @function toggleHorizontalMenuMobile
   *   @description Open Secondary Sidebar on Mobile - Service
   */
  toggleSecondarySideBar() {
    console.log('hi');
    this._secondarySideBar = this._secondarySideBar == true ? false : true;
    this.toggler.toggleSecondarySideBar(this._secondarySideBar);
  }

  /** @function toggleHorizontalMenuMobile
   *   @description Call Horizontal Menu Toggle Service for mobile
   */
  toggleHorizontalMenuMobile() {
    this._mobileHorizontalMenu = this._mobileHorizontalMenu == true ? false : true;
    this.toggler.toggleMobileHorizontalMenu(this._mobileHorizontalMenu);
  }

  @HostListener('window:resize', [])
  onResize() {
    this.autoHideMenuPin();
  }

  //Utils
  autoHideMenuPin() {
    if (window.innerWidth < 1025) {
      if (pg.hasClass(document.body, 'menu-pin')) {
        pg.addClass(document.body, 'menu-unpinned');
        pg.removeClass(document.body, 'menu-pin');
      }
    }
    else {
      if (pg.hasClass(document.body, 'menu-unpinned')) {
        pg.addClass(document.body, 'menu-pin');
      }
    }
  }
}
